<div class="card">
  @for (data of templateData; track data; let x = $index) {
    <!-- image sections -->
    @if (data.sectionType === 'image') {
      <div #ImageSection class="section image-section" [ngStyle]="{'height.px': data.sectionHeight}" [attr.section]="x">
        <img src="{{data.section.imageUrl}}" [ngStyle]="{'height.px': data.sectionHeight, 'object-fit': data.section.isMissingImage ? 'cover' : 'null'}" />
        <!-- tag -->
        @if (data.section.tag.isValid) {
          <div class="tag" lm-field-style [isTag]="true" [fieldStyle]="data.section.tag.style">
            <span class="tag-content">{{data.section.tag.tagValue}}</span>
          </div>
        }
      </div>
    }
    <!-- title sections -->
    @if (data.sectionType === 'title') {
      <div #TitleSection
        class="section title-section"
        [ngStyle]="{ 'height.px': data.sectionHeight }"
        [attr.section]="x"
        lm-tooltip [title]="data.section.displayValue"
        >
        @if (data.section.navigationParams) {
          <h3 [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }">
            <a href=""
              class="hyperlink"
              [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }"
              (click)="onUILinkEvent(data.section.navigationParams)">
              {{data.section.displayValue}}
            </a>
          </h3>
        } @else {
          <h3 [ngStyle]="{'-webkit-line-clamp' : data.section.lines ? data.section.lines : 1 }">{{data.section.displayValue}}</h3>
        }
      </div>
    }
    <!-- row sections -->
    @if (data.sectionType === 'row') {
      <div class="section row-section" [style.height.px]="data.section?.fields[0]?.height" [attr.section]="x">
        @for (field of data.section?.fields; track field) {
          @if (!field.actionReference) {
            <ng-container *ngTemplateOutlet="Fields; context: {field: field}"></ng-container>
          }
          @if (field.actionReference) {
            <ng-container *ngTemplateOutlet="Actions; context: {action: field}"></ng-container>
          }
        }
      </div>
    }
    <!-- field sections -->
    @if (data.sectionType === 'field') {
      <div class="section field-section" [style.height.px]="data.sectionHeight" [attr.section]="x">
        @for (field of data.section?.fields; track field; let i = $index) {
          <div [attr.row]="i">
            <ng-container *ngTemplateOutlet="Fields; context: {field: field}">
              @if (field.value && !(field.isInternalNavigation || field.isExternalNavigation || field.displayAsTag)) {
                <p>{{field.displayValue}}</p>
              }
            </ng-container>
          </div>
        }
      </div>
    }
    <!-- action sections -->
    @if (data.sectionType === 'action') {
      <div class="section action-section" [style.height.px]="data.sectionHeight" [attr.section]="x">
        <div class="left-section">
          @for (action of data.section?.actions.leftSection; track action) {
            <ng-container  *ngTemplateOutlet="CheckControl; context: {checkcontrol: action}"></ng-container>
          }
        </div>
        <div class="right-section">
          @for (action of data.section?.actions.rightSection; track action) {
            <ng-container  *ngTemplateOutlet="Actions; context: {action: action}"></ng-container>
          }
        </div>
      </div>
    }
  }
</div>

<!-- field template -->
<ng-template #Fields let-field="field">
  <div class="sectioned-card-field" lm-tooltip [content]="field.displayValue">
    @if (field.label) {
      <label class="lm-card-label" lm-text-style [textStyle]="field?.textStyle">{{field.label}}:</label>
    }

    @if (field.hidden) {
      <div class="hidden-field">&nbsp;</div>
    }

    <!-- rating field -->
    @if (field.displayAsRating) {
      <div soho-rating class="is-readonly">
        @for (option of field.ratingOptions; track option; let i = $index) {
          <input type="radio" name="rating_options" id="{{option.id}}" [ngClass]="option.class" [attr.disabled]="true">
          <label for="{{option.id}}" class="lm-card-label">
            <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
              <use [attr.xlink:href]="option.href"></use>
            </svg>
            <span class="audible">{{option.label}}</span>
          </label>
        }
      </div>
    }

    <!-- links -->
    @if (!field.displayAsTag && !field.displayAsRating) {
      @if (field.isExternalNavigation) {
        <a
          href="{{field?.httpUrl}}"
          class="lm-card-field hyperlink"
          [target]="field.openExternal ? '_blank' : ''"
          lm-tooltip [title]="field?.displayValue"
          lm-field-style [fieldStyle]="field?.fieldStyle"
          (click)="external(field, $event)"
        >{{field?.displayValue}}</a>
      }
      @if (field.isInternalNavigation) {
        <a
          href="javascript:void(0)"
          class="lm-card-field hyperlink"
          (click)="navigate(field)"
          lm-tooltip [title]="field?.displayValue"
          lm-field-style [fieldStyle]="field?.fieldStyle"
        >{{field?.displayValue}}</a>
      }
    }

    <!-- standard field -->
    @if (field.isField && (!field.displayAsRating && !field.displayAsTag && !field.isFormText)) {
      @if (!(field.isExternalNavigation || field.isInternalNavigation)) {
        <p
          class="lm-card-field sectioned-card-field-text"
          [ngStyle]="{'-webkit-line-clamp': field.lines}"
          lm-field-style [fieldStyle]="field?.fieldStyle"
        >{{field.displayValue}}</p>
      }
    }

    <!-- form text -->
    @if (field.isFormText && !field.displayAsTag && !field.isRichText && !field.displayAsRating && !(field.isExternalNavigation || field.isInternalNavigation)) {
      <span
        [ngStyle]="{'-webkit-line-clamp' : field.lines }"
        class="lm-card-field {{field?.displayAsAlert?.color}}"
        lm-text-style [textStyle]="field?.textStyle"
        >
        @if (field.icon && field.icon.sohoIcon || field?.displayAsAlert?.icon) {
          <svg soho-icon
            class="icon {{field?.displayAsAlert?.color}}"
            [icon]="field?.displayAsAlert?.icon ? field?.displayAsAlert?.icon : field.icon.icon"
            [attr.title]="field.displayValue"
            lm-tooltip [content]="field.displayValue" [placement]="'bottom'">
          </svg>
        }
        @if (field.icon && !field.icon.sohoIcon && !field?.displayAsAlert) {
          <img class="icon" src="{{field.icon.iconUrl}}" />
        }
        <span>{{field?.displayValue}}</span>
      </span>
    }

    <!-- display as tag -->
    @if (field.displayAsTag) {
      @if (field.isField) {
        <span class="lm-card-field tag"
          [style.color]="!!field?.fieldStyle?.color ? 'white' : null"
          lm-field-style [fieldStyle]="field?.fieldStyle" [isTag]="true"
        >{{field?.displayValue}}</span>
      }
      @if (field.isExternalNavigation) {
        <a
          href="{{field?.httpUrl}}"
          [target]="field.openExternal ? '_blank' : ''"
          class="lm-card-field tag is-clickable"
          [style.color]="!!field?.fieldStyle?.color ? 'white' : null"
          lm-field-style [fieldStyle]="field?.fieldStyle" [isTag]="true"
          >
          <span>{{field?.displayValue}}</span>
          <span>
            <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
              <use xlink:href="#icon-caret-right"></use>
            </svg>
            <span class="audible"></span>
          </span>
        </a>
      }
      @if (field.isInternalNavigation) {
        <a
          href="javascript:void(0)"
          (click)="navigate(field)"
          class="lm-card-field tag is-clickable"
          [style.color]="!!field?.fieldStyle?.color ? 'white' : null"
          lm-field-style [fieldStyle]="field?.fieldStyle" [isTag]="true"
          >
          <span>{{field?.displayValue.trim()}}</span>
          <span>
            <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
              <use xlink:href="#icon-caret-right"></use>
            </svg>
            <span class="audible"></span>
          </span>
        </a>
      }
    }
  </div>
</ng-template>

<!-- check control template -->
<ng-template #CheckControl let-checkcontrol="checkcontrol">
  <!--    <ng-container *ngIf="checkcontrol.displayAsBox">-->
  <!--        <input soho-checkbox type="checkbox" aria-hidden="true" role="presentation" class="checkbox" tabindex="0">-->
  <!--        <label class="checkbox-label"><span class="audible"></span></label>-->
<!--    </ng-container>-->
<!--    <div *ngIf="checkcontrol.displayAsSwitch" class="switch">-->
<!--        <input soho-checkbox class="switch">-->
<!--        <label soho-label [forCheckBox]="true"><span class="audible"></span></label>-->
<!--    </div>-->
<!--    <ng-container *ngIf="checkcontrol.displayAsStar">-->
<!--        <button soho-button="favorite"></button>-->
<!--    </ng-container>-->
</ng-template>

<!-- actions template -->
<ng-template  #Actions let-action="action">
  <!-- icon only -->
  @if (action.isIconOnly) {
    @if (action.isIconOnly) {
      <button
        soho-button="icon" [isToggle]="action?.isToggle" [isTogglePressed]="action.state?.isPressed" [icon]="action.icon"
        lm-tooltip [title]="action.displayTooltip ? action.actionReference?.label || action.actionReference?.tooltip : null"
        class="btn lm-icon-button"
        lm-field-style [fieldStyle]="action?.fieldStyle"
        [attr.data-action-reference]="stringifyJson(action?.actionReference)"
        [ngClass]="{'lm-missing-soho-icon': !action.icon}"
        (click)="onActionClicked($event)"
        >
        @if (action.icon) {
          <span>{{action.actionReference?.label}}</span>
        }
        <ng-container>
          <!-- Need nbsp, if span is empty then ids-enterprise css will hide it -->
          @if (!action.icon) {
            <span [ngStyle]="{'background-image': 'url(' + action.iconUrl + ')'}">&nbsp;</span>
          }
          <span class="audible">{{action.actionReference?.label}}</span>
        </ng-container>
      </button>
    }
  } @else {
    <!-- httpUrl (external link)-->
    @if (action.isOpenExternal) {
      <a
        [ngClass]="{'btn hyperlink': action.isDisplayAsLink, 'btn': !action.isDisplayAsLink}"
        [attr.href]="action.httpUrl"
        lm-field-style [fieldStyle]="action?.fieldStyle"
        target="_blank"
        (click)="external(action, $event)"
        >
        <span>{{action.actionReference?.label}}</span>
      </a>
    }
    <!-- display buttons as links -->
    @if (action.isDisplayAsLink && !action.isOpenExternal) {
      <button
        class="btn hyperlink"
        lm-field-style [fieldStyle]="action?.fieldStyle"
        [attr.data-action-reference]="stringifyJson(action?.actionReference)"
        (click)="onActionClicked($event)"
        >
        <span>{{action.actionReference?.label}}</span>
      </button>
    }
    <!-- action buttons -->
    @if (!action.isDisplayAsLink && !action.isOpenExternal) {
      <button
        class="btn"
        [ngClass]="{'lm-is-primary': action?.isPrimary}"
        lm-field-style [fieldStyle]="action?.fieldStyle"
        [attr.data-action-reference]="stringifyJson(action?.actionReference)"
        (click)="onActionClicked($event)"
        >
        <span>{{action.actionReference?.label}}</span>
      </button>
    }
  }
</ng-template>
